import * as bepolia from '@/assets/data/contracts/bepolia.json';
import { Contracts } from '../types';

const contracts: Contracts = {
  merkleRedeem: '',
  merkleOrchard: '',
  merkleOrchardV2: bepolia.MerkleOrchard,
  multicall: '0xcA11bde05977b3631167028862bE2a173976CA11',
  authorizer: bepolia.Authorizer,
  vault: bepolia.Vault,
  weightedPoolFactory: bepolia.WeightedPoolFactory,
  stablePoolFactory: bepolia.StablePoolFactory,
  composableStablePoolFactory: bepolia.ComposableStablePoolFactory,
  lidoRelayer: '',
  balancerHelpers: bepolia.BalancerHelpers,
  batchRelayer: bepolia.BalancerRelayer,
  veBAL: '',
  gaugeController: '',
  gaugeFactory: '',
  balancerMinter: '',
  tokenAdmin: '',
  veDelegationProxy: bepolia.VotingEscrowDelegationProxy,
  veBALHelpers: '',
  feeDistributor: '',
  feeDistributorDeprecated: '',
  faucet: '',
  omniVotingEscrow: '',
  claimSubmission: '',
};

export default contracts;
